module.exports = __webpack_public_path__ + "img/pois.bcb05d09.svg";